import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";

import BusTable from "../BusCreation/Bus_Table";

import Rout_Table from "../BusRoute/Rout_Table";

// import Main_Page_staff from "../Driver/Main_Page_staff";
//   import Print_pdf_classDetails from "./Print_pdf_classDetails";

const Staff_Bus_details = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Bus Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              {/* <Button
                marginRight={2}
  
                  className="export-button"
                  // display={{ base: "none", md: "flex" }}
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  // onClick={handlePrint} 
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button> */}
              {/* Add a Button to trigger the Bus_Create_form Modal */}
              {/* <Bus_Create_form /> 
                <Route_create />
                <Create_Driver /> */}
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Bus </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Bus Details</span>
          </Link>
        </Box>
      </div>

      <Box p={6} flex="2" mb={9}>
        <Tabs variant="enclosed" colorScheme="teal">
          <TabList>
            <Tab>Route</Tab>

            <Tab>Bus</Tab>
            {/* <Tab>Staff</Tab> */}
          </TabList>

          <TabPanels>
            <TabPanel p={1} mt="10px">
              <Rout_Table />
            </TabPanel>

            <TabPanel p={1} mt="10px">
              <BusTable />
            </TabPanel>

            {/* <TabPanel p={0} mt="10px">
              <Main_Page_staff />
            </TabPanel> */}
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default Staff_Bus_details;
